import React, { useState, forwardRef, useImperativeHandle, useEffect, useContext } from 'react';
import { Checkbox, FormGroup, FormControlLabel, Snackbar, Typography, TextField } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDateTimePicker } from '@material-ui/pickers';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import MuiAlert from '@material-ui/lab/Alert';
import { Context } from '../contexts/siteContext';
import { HttpService } from '../../apiAuthorization/httpService';
import { Backdrop, CircularProgress } from '@material-ui/core/';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import { ConvertToCurrentTimeZone } from '../header/timeFormatter';

const useStyles = makeStyles(theme => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    }
}));

const SafeRoomCheckList = forwardRef((props, ref) => {
    const classes = useStyles();
    const { patientSittingSelected, onAttendantCheckListShow, onDisableWithStyle, startObservation, isManager, onSafetyChecklistSave } = props;
    const [safeRoomCheckList, setSafeRoomCheckList] = useState([]);
    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const { defaultSite } = useContext(Context);
    const [backDrop, setBackDrop] = useState(false);
    const posGroupId = defaultSite.IntegratedSystem.POSGroupId;
    const [patientSafetyRoomChecklistDto, setpatientSafetyRoomChecklistDto] = useState(props.patientSittingSelected.POSAttendantChecklist ? props.patientSittingSelected.POSAttendantChecklist : {
        SiteId: defaultSite.id,
        ObserverSignature: null,
        RNSignature: null,
        SignatureDateTime: ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY hh:mm a", null, defaultSite) //formattedDate 
    });

    function Alert(props) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    };

    const closeErrorSnackbar = () => {
        setOpenError(false);
    };

    const openErrorSnackbar = () => {
        setOpenError(true);
    };

    const disabledSafeRoomChecklist = function () {
        var disabled = false;
        safeRoomCheckList.forEach((item) => {
            if (!item.Checked) {
                disabled = true;
            }
        });
        if (txtChangedObserverSignature(patientSafetyRoomChecklistDto.ObserverSignature)) {
            disabled = true;
        }

        return disabled;
    };

    const txtChangedObserverSignature = function (ObserverSign) {
        var disabled = false;
        safeRoomCheckList.forEach((item) => {
            if (!item.Checked) {
                disabled = true;
            }
        });
        if (disabled === false && posGroupId === 2) {
            if (ObserverSign === '' || ObserverSign === null) {
                disabled = true;
            }
            else {
                disabled = false;
            }
        }
        return disabled;
    };

    const okSafeRoomChecklist = function () {

        if (disabledSafeRoomChecklist()) {
            setErrorMessage("If any issues are not able to be resolved, please contact manager");
            openErrorSnackbar();
            return false;
        }

        //if first time or trturning for a shift change
        if (patientSittingSelected.POSAttendantChecklist.IsShowPOSAttendantChecklist) {
            var _checklistDto = { ...patientSittingSelected.POSAttendantChecklist };
            _checklistDto.ObserverSignature = patientSafetyRoomChecklistDto.ObserverSignature;
            _checklistDto.RNSignature = patientSafetyRoomChecklistDto.RNSignature;
            _checklistDto.SignatureDateTime = patientSafetyRoomChecklistDto.SignatureDateTime;

            onSafetyChecklistSave(_checklistDto);
            onAttendantCheckListShow(true);
            onDisableWithStyle(true);
        }
        else {
            startObservation(patientSittingSelected);
        }
    };
    
    const getSafeRoomOptions = () => {
        setBackDrop(true);
        HttpService.post('/PatientSitting/GetSafeRoomOptions', { POSGroupId: defaultSite.IntegratedSystem.POSGroupId })
            .then((result) => {
                const safeRoomOptions = result.safeRoomOptions.map(item => ({
                    ...item,
                    Checked: false
                }));
                setSafeRoomCheckList(safeRoomOptions);
                setBackDrop(false);
            },
            (error) => {
                console.log(error);
                setBackDrop(false);
            });
    };

    useEffect(() => {
        getSafeRoomOptions();
        if (defaultSite.IntegratedSystem.POSGroupId === 2) {
            setpatientSafetyRoomChecklistDto({ ...patientSafetyRoomChecklistDto, SignatureDateTime: ConvertToCurrentTimeZone(new Date(), "MM/DD/YYYY hh:mm a", null, defaultSite) });
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useImperativeHandle(ref, () => {
        return {
            save: okSafeRoomChecklist
        };
    });

    const patientSafetyRoomChecklisDateChanged = (key, date) => {
        date = moment(date).format("MM/DD/YYYY hh:mm a");
        var _setpatientSafetyRoomChecklistDto = { ...setpatientSafetyRoomChecklistDto };
        _setpatientSafetyRoomChecklistDto[key] = date;
        setpatientSafetyRoomChecklistDto(_setpatientSafetyRoomChecklistDto);
    };

    return (
        <div>
            <Backdrop className={classes.backdrop} id="patientSittingBackdrop" open={backDrop}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Snackbar open={openError} autoHideDuration={3000} onClose={closeErrorSnackbar} style={{ height: "100%" }}>
                <Alert onClose={closeErrorSnackbar} severity="error">
                    {errorMessage}
                </Alert>
            </Snackbar>
            <FormGroup style={{ display: "flex" }}>
            {
                safeRoomCheckList.map((item) => {
                    return (
                        <FormControlLabel
                            key={item.Id}
                            control={
                                <Checkbox
                                    onChange={(e) => { item.Checked = e.target.checked; onDisableWithStyle(disabledSafeRoomChecklist()); }}
                                    value="Checked"
                                />
                            }
                            label={item.Description}
                            style={{ color: '#4183c4' }}
                        />
                    )
                })
            }
                
            </FormGroup>
            {(posGroupId === 2) &&
                <>
                    < Grid container direction="row" alignItems="center" spacing={1}>
                        <Grid item xs={4} sm={4}>
                            <Typography variant="subtitle2" gutterBottom>
                                Signature of 1:1 Observer: <span style={{ color: 'red' }}>*</span>
                            </Typography>
                            <TextField
                                size="small"
                                fullWidth  
                                variant="outlined"
                                value={patientSafetyRoomChecklistDto.ObserverSignature || ""}
                                onChange={(e) => { setpatientSafetyRoomChecklistDto({ ...patientSafetyRoomChecklistDto, ObserverSignature: e.target.value.trimStart() }); onDisableWithStyle(txtChangedObserverSignature(e.target.value.trimStart()));}}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid item xs={4} sm={4}>
                            <Typography variant="subtitle2" gutterBottom>
                                RN Name:
                            </Typography>
                            <TextField
                                size="small"
                                fullWidth  
                                variant="outlined"
                                value={patientSafetyRoomChecklistDto.RNSignature || ""}
                                onChange={(e) => { setpatientSafetyRoomChecklistDto({ ...patientSafetyRoomChecklistDto, RNSignature: e.target.value.trimStart() }); }}
                                InputLabelProps={{ shrink: true }}
                            />
                        </Grid>
                        <Grid item xs={4} sm={4}>
                            <Typography variant="subtitle2" gutterBottom>
                                Date/Time <span style={{ color: 'red' }}>*</span>
                            </Typography>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDateTimePicker
                                    fullWidth
                                    hideTabs
                                    autoOk
                                    variant="inline"
                                    inputVariant="outlined"
                                    id="SignatureDateTime"
                                    format="MM/dd/yyyy hh:mm a"
                                    size="small"
                                    disableFuture="true"
                                    value={patientSafetyRoomChecklistDto.SignatureDateTime}
                                    onChange={date => patientSafetyRoomChecklisDateChanged('SignatureDateTime', date)}
                                    InputAdornmentProps={{ position: "start" }}
                                    PopoverProps={{
                                        anchorOrigin: { horizontal: "left", vertical: "bottom" },
                                        transformOrigin: { horizontal: "left", vertical: "top" }
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                    </Grid>
                </>
            }
        </div>
    );
});

export default SafeRoomCheckList;
